export default "__VITE_ASSET__45c8ba39__"